import { render, staticRenderFns } from "./BookerCalendar.vue?vue&type=template&id=24d5ba5a&scoped=true"
import script from "./BookerCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./BookerCalendar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BookerCalendar.vue?vue&type=style&index=0&id=24d5ba5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5ba5a",
  null
  
)

export default component.exports